var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('font-awesome-icon',{attrs:{"id":_vm.tooltipId,"icon":_vm.icon}}),_c('b-tooltip',{attrs:{"target":_vm.tooltipId,"custom-class":"info-popup","position":"topright"}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }